export default {
  title: 'Configurar entregas de pacotes',
  form: {
    title: 'Criar entrega',
    companies: {
      label: 'Empresas',
    },
  },
  table: {
    title: 'Histórico de entregas',
    fields: {
      name: 'Empresa',
      fulfilled: 'Entregue em',
    },
  },
  buttons: {
    create_fulfillment: 'Criar entrega',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_create_fulfillment: 'Falha ao criar entrega',
  },
};
